// API
export { historyService } from './api/history.service';

// Types
export type {
  HistoryItem,
  HistoryFilters,
  HistorySortBy,
  HistoryParams,
  HistoryResponse,
  RenderHistoryItem,
  RenderHistoryResponse,
  AlbumHistoryItem,
  JobHistoryItem,
  JobHistoryResponse,
  JobStatus,
} from './model/history.types';

// Utilities
export {
  renderHistoryToHistoryItem,
  jobHistoryToHistoryItem,
  isRenderHistoryItem,
  isAlbumHistoryItem,
  isEstimateHistoryItem,
  isActiveJob,
  isCompletedJob,
} from './model/history.types';

// Hooks - Concepts History (legacy - for project page)
export {
  useConceptsHistory,
  useInfiniteConceptsHistory,
  useToggleFavorite,
  useDeleteConcept,
  getSortString,
} from './hooks/use-concepts-history';

// Hooks - Render History (for dashboard and history screen)
export {
  useRenderHistory,
  useInfiniteRenderHistory,
  useToggleRenderFavorite,
  useDeleteRender,
} from './hooks/use-concepts-history';

// Hooks - Job History (renders + albums combined)
export {
  useJobHistory,
  useInfiniteJobHistory,
  useDeleteJobItem,
  useActiveJobs,
  invalidateJobHistory,
} from './hooks/use-concepts-history';

export {
  useInfiniteTrash,
  useRestoreTrashItem,
} from './hooks/use-trash';

export type {
  TrashItem,
  TrashItemType,
  TrashResponse,
  TrashSubtypeFilter,
} from './model/trash.types';

export { isTrashProject, trashItemProjectId } from './model/trash.types';

export {
  useHistoryFilters,
  type FilterType,
  type SubtypeFilter,
} from './hooks/use-history-filters';

// Stores
export { useHistorySearchStore } from './model/history-search-store';

// Components
export { HistoryFilters as HistoryFiltersComponent } from './ui/HistoryFilters';
export { HistoryList } from './ui/HistoryList';
export { TrashList } from './ui/TrashList';
export { TrashCard } from './ui/TrashCard';
